export default "__VITE_ASSET__BZGTEqJw__"